<template>
	<div>
		<div class="flex">
			<div class="flex-grow pr-4 py-1">
				<h4 class="text-5xl text-green-1000 leading-none font-sans">{{ trip.incomplete ? '--' : trip.points }}</h4>
				<h5 class="text-2xl text-green-700 leading-none -mt-2">points</h5>
			</div>
			<div class="mt-1 mb-0 text-right flex flex-col">
				<h4 class="text-2xltext-green-1000 leading-none font-bold">{{ trip.length }} <span class="text-green-700 font-normal">checkpoints</span></h4>
				<h4 class="text-2xl text-red-600 leading-none font-bold pt-1">{{ trip.theme }}</h4>
				<h4 class="text-xl text-green-800 leading-none pt-1">{{ trip.date }} - <span class="capitalize">{{ trip.city.replace("_", " ") }}</span></h4>
			</div>
		</div>
		
		<a tabindex="0" @click="expanded = !expanded" @keypress.enter="expanded = !expanded" class="flex mt-5 pt-4 pb-3 -mx-5 px-5 border-t border-solid border-green-500 cursor-pointer focus:outline-none" :class="{ 'border-b': (!(!trip.under_review && !trip.incomplete && !trip.invalid && (trip.share_code == '' || (!belongs_to_authed && !trip.force_include_code))) || expanded == true) }">
			<div class="flex-grow">
				<h5 v-if="!expanded" class="font-sans text-green-700">SHOW ROUTE</h5>
				<h5 v-if="expanded" class="font-sans text-green-700">HIDE ROUTE</h5>
			</div>
			<div>
				<svg v-if="!expanded" class="text-green-700" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>
				<svg v-if="expanded" class="text-green-700" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="18 15 12 9 6 15"></polyline></svg>
			</div>
		</a>
		
		<div v-if="expanded" class="bg-green-100 py-3 -mx-5 px-5" :style="{ 'box-shadow': (!trip.under_review && !trip.incomplete && !trip.invalid && (trip.share_code == '' || !belongs_to_authed) && trip.force_include_code == false) ? 'inset 0px 45px 30px -50px #7c9c8c' : 'inset 0px -45px 30px -50px #7c9c8c, inset 0px 45px 30px -50px #7c9c8c' }">
			<div class="flex py-2 sm:py-3 relative" v-for="(checkpoint, index) in trip.route" v-bind:key="checkpoint.name">
				<div class="flex flex-col">
					<div v-if="index == 0" class="absolute bottom-0 bg-green-500 pasttrip-step_bar" style="height: 50%;"></div>
					<div v-if="index > 0 && index < trip.route.length - 1" class="h-full absolute top-0 bg-green-500 pasttrip-step_bar"></div>
					<div v-if="index == trip.route.length - 1" class="absolute top-0 bg-green-500 pasttrip-step_bar" style="height: 50%;"></div>
					
					<div class="flex-grow"></div>
					<div v-if="index == 0" class="relative z-10 rounded-full mr-4 my-1 bg-green-500 text-white text-3xl p-2 leading-none text-center align-middle pasttrip-start_circle"></div>
					<div v-if="index > 0" :class="{'bg-green-500': checkpoint.title == 'Locked', 'bg-green-900': checkpoint.title != 'Locked'}" class="relative z-10 rounded-full mr-4 my-1 text-white text-2xl p-2 leading-none text-center align-middle pasttrip-step_circle">
						{{ checkpoint.title == "Locked" ? '' : index }}
					</div>
					<div class="flex-grow"></div>
				</div>
				<div class="flex flex-col flex-grow">
					<div class="flex-grow"></div>
					<h3 class="text-2xl leading-none align-middle font-sans" :class="{'text-green-1000': !(checkpoint.title == 'Start' || checkpoint.title == 'Locked')}">{{ checkpoint.title }}</h3>
					<h4 v-if="checkpoint.time" class="text-xl text-green-1000 leading-none align-middle font-body -mb-1" style="min-height: 8px;">{{ checkpoint.time }}</h4>
					<div class="flex-grow"></div>
				</div>
			</div>
		</div>
		
		<div v-if="(belongs_to_authed || trip.force_include_code) && trip.share_code != ''">
			<div class="block bg-white px-5 pt-5 pb-6 -mx-5">
				<div v-if="belongs_to_authed">
					<h4 class="text-2xl text-green-1000 leading-none font-sans">Share your score</h4>
					<div class="flex mt-2 mb-6">
						<div class="flex">
							<a v-if="share_api" @click="share" @keypress.enter="share" tabindex="0" style="padding-top: 5px; padding-bottom: 7px;" class="mr-2 px-2 cursor-pointer rounded-lg border-4 border-solid border-green-500 text-green-900 hover:bg-green-200 focus:bg-green-200">
								<svg class="inline-block" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="18" cy="5" r="3"></circle><circle cx="6" cy="12" r="3"></circle><circle cx="18" cy="19" r="3"></circle><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line></svg>
								<span class="align-middle inline-block text-sm pt-1 pl-1">SHARE</span>
							</a>
							<div v-else class="flex">
								<a :href="'https://twitter.com/intent/tweet?text=' + encodeURIComponent(share_copy)" target="_blank" tabindex="0" style="padding-top: 5px; padding-bottom: 7px;" class="mr-2 px-2 cursor-pointer rounded-lg border-4 border-solid border-green-500 text-green-900 hover:bg-green-200 focus:bg-green-200">
									<svg class="inline-block" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path></svg>
									<span class="align-middle text-sm pt-1 pl-1 hidden md:inline-block">TWITTER</span>
								</a>
								<a :href="'whatsapp://send?text=' + encodeURIComponent(share_copy)" target="_blank" tabindex="0" style="padding-top: 5px; padding-bottom: 7px;" class="mr-2 px-2 cursor-pointer rounded-lg border-4 border-solid border-green-500 text-green-900 hover:bg-green-200 focus:bg-green-200">
									<svg class="inline-block" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path></svg>
									<span class="align-middle text-sm pt-1 pl-1 hidden md:inline-block">WHATSAPP</span>
								</a>
							</div>
							<a tabindex="0" :class="'snapchat-share-button-' + trip.id" :data-share-url="'https://app.lostinthecity.xyz/trips/' + trip.username + '/' + trip.id" style="padding-top: 5px; padding-bottom: 7px;" class="mr-2 px-2 cursor-pointer rounded-lg border-4 border-solid border-green-500 text-green-900 hover:bg-green-200 focus:bg-green-200">
								<svg class="inline-block" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path></svg>
								<span class="align-middle text-sm pt-1 pl-1 hidden md:inline-block">SNAPCHAT</span>
							</a>
						</div>
						<a @click="copyShare" @keypress.enter="copyShare" tabindex="0" style="padding-top: 5px; padding-bottom: 7px;" class="px-2 cursor-pointer rounded-lg border-4 border-solid border-green-500 text-green-900 hover:bg-green-200 focus:bg-green-200">
							<svg class="inline-block" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path><rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect></svg>
							<span class="align-middle inline-block text-sm pt-1 pl-1">COPY</span>
						</a>
					</div>
					<input :id="'challenge_share-' + trip.id" class="fixed" style="top: -100%; left: -100%;" v-model="share_copy" readonly />
				</div>
				
				<div v-if="$parent.user.username == ''">
					<h4 class="text-2xl text-green-1000 leading-none font-sans">Challenge {{ '@' + trip.username }}</h4>
					<p class="text-xl text-green-1000 leading-tight font-body mt-1">Join Lost in the City to see if you can beat their score</p>
					
					<div class="block mt-4 mb-2">
						<router-link to="/register" class="px-3 py-2 rounded-lg cursor-pointer text-white text-xl bg-grey-700 hover:bg-grey-800 focus:bg-grey-800">Register now</router-link>
					</div>
				</div>
				<div v-else>
					<div v-if="belongs_to_authed">
						<h4 class="text-2xl text-green-1000 leading-none font-sans">Challenge a friend</h4>
						<p class="text-xl text-green-1000 leading-tight font-body mt-1">Share the code below with your friends, and see if they can beat your score:</p>
					</div>
					<div v-else>
						<h4 class="text-2xl text-green-1000 leading-none font-sans">Challenge your friend</h4>
						<p class="text-xl text-green-1000 leading-tight font-body mt-1">Use the code below when starting a new challenge to see if you can beat {{ '@' + trip.username }}'s score</p>
					</div>
					<div class="flex mt-2">
						<div class="flex-grow pr-2">
							<input :id="'challenge_code-' + trip.id" class="w-full rounded-lg px-3 py-1 text-2xl bg-transparent border-4 border-solid border-green-500 text-green-900 font-sans" :value="trip.share_code" placeholder="Share this code with your friends" readonly />
						</div>
						<a @click="copyCode" @keypress.enter="copyCode" tabindex="0" style="padding-top: 5px;" class="px-2 py-1 cursor-pointer rounded-lg border-4 border-solid border-green-500 text-green-900 hover:bg-green-200 focus:bg-green-200">
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-clipboard"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path><rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect></svg>
						</a>
					</div>
				</div>
			</div>
		</div>
		
		<div v-if="trip.under_review" class="-mx-5">
			<error class="w-full px-5" colour="purple" icon="triangle_error" title="Pending review" :body="'This trip has been flagged as suspicious, and is currently awaiting review from a moderator. It cannot be shared with other users or seen on your profile yet. <span class=\'block mt-4 text-lg\'><b>Support reference:</b> <span class=\'select-text\'>' + trip.id + '</span></span>'" />
		</div>
		<div v-else-if="trip.incomplete" class="py-5">
			<h4 class="text-2xl text-green-1000 leading-none font-sans">Incomplete trip</h4>
			<p class="text-xl text-green-1000 leading-tight font-body mt-1">
				You either cancelled your trip before completing it, or it was automatically
				ended if you closed the app for a long time during the challenge.
				
				<span class="block mt-4 text-lg"><b>Support reference:</b> <span class="select-text">{{ trip.id }}</span></span>
			</p>
		</div>
		<div v-else-if="trip.invalid">
			<error class="w-full px-5" colour="red" icon="triangle_error" title="Invalid trip" :body="'This trip has been reviewed by a moderator and marked as invalid. It can no longer be shared with other users or seen on your profile. <span class=\'block mt-4 text-lg\'><b>Support reference:</b> <span class=\'select-text\'>' + trip.id + '</span></span>'" />
		</div>
	</div>
</template>

<style>
.pasttrip-step_bar {
	width: 8px;
	left: 16px;
}

.pasttrip-start_circle {
	font-family: monospace;
	height: 20px;
	width: 20px;
	margin-left: 10px;
	margin-right: 18px;
}

.pasttrip-step_circle {
	font-family: monospace;
	height: 30px;
	width: 30px;
    margin-left: 5px;
    margin-right: 13px;
	padding-top: 6px;
}
</style>

<script>
import ErrorBox from '../components/ErrorBox.vue';

export default {
	name: 'PastTripDetails',
	props: ['trip'],
	components: {
		'error': ErrorBox
	},
    data() {
        return {
			belongs_to_authed: false,
			expanded: false,
			share_api: false,
			share_title: "",
			share_text: "",
			share_url: ""
        }
	},
	created() {
		if (this.$parent.user.username == this.trip.username) {
			this.belongs_to_authed = true;
		}
		
		if (navigator.share) this.share_api = true;
		
		this.share_title = "Lost in the Ciy challenge";
		this.share_text = "I got a total score of " + this.trip.points
						+ " on the Lost in the City challenge in "
						+ this.toTitleCase(this.trip.city.replace("_", " ")) + "!";
		this.share_url = "https://app.lostinthecity.xyz/trips/" + this.trip.username + "/" + this.trip.id;
		
		this.share_copy = this.share_text + " " + this.share_url;
	},
	mounted() {
		window.snap.creativekit.initalizeShareButtons(
			document.getElementsByClassName("snapchat-share-button-" + this.trip.id)
		);
	},
	methods: {
		toTitleCase(phrase) {
			return phrase
			.toLowerCase()
			.split(' ')
			.map(word => word.charAt(0).toUpperCase() + word.slice(1))
			.join(' ');
		},
		share() {
			if (!navigator.share) return;
			
			navigator.share({
				title: this.share_title,
				text: this.share_text,
				url: this.share_url
			});
		},
		copyShare() {
			var copyText = document.getElementById("challenge_share-" + this.trip.id);
			copyText.select();
			copyText.setSelectionRange(0, 99999);
			document.execCommand("copy");
		},
		copyCode() {
			var copyText = document.getElementById("challenge_code-" + this.trip.id);
			copyText.select();
			copyText.setSelectionRange(0, 99999);
			document.execCommand("copy");
		}
	}
}
</script>